import { createTheme, responsiveFontSizes } from '@mui/material/styles';
import { MuiPalette } from './Palette/MuiPalette';
import { MuiTypography } from './MuiTypography/MuiTypography';
import { MuiToggleButtonStyled } from './MuiToggleButtonStyled/MuiToggleButtonStyled';
import { MuiButtonStyled } from './MuiButtonStyled/MuiButtonStyled';
import { MuiAutocompleteStyled } from './MuiAutocompleteStyled/MuiAutocompleteStyled';
import { MuiFormHelperTextStyled } from './MuiFormHelperTextStyled/MuiFormHelperTextStyled';
import { MuiTextFieldStyled } from './MuiTextFieldStyled/MuiTextFieldStyled';

export const theme = responsiveFontSizes(
    createTheme({
        palette: MuiPalette,
        typography: MuiTypography,
    }),
);

MuiToggleButtonStyled(theme);
MuiButtonStyled(theme);
MuiAutocompleteStyled(theme);
MuiFormHelperTextStyled(theme);
MuiTextFieldStyled(theme);
